// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"98afc2c2","43":"0bd1bfdf","160":"bb788f3e","208":"835bebc5","284":"6dab5f79","293":"6f631975","406":"6077da92","516":"4e42566c","519":"ff459837","643":"c5f13e91","648":"b8d7017d","910":"5e0fe72c","917":"bbc569f1","946":"6de82662"}[chunkId] + ".chunk.js";
};